exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-postal-code-search[data-v-658345ae]{cursor:pointer}.link-postal-code-search:hover small[data-v-658345ae]{text-decoration:underline}", ""]);

// exports
